<template>
    <div class="message-container" ref="messageContainer" v-loading="dataLoading">
        <div class="user-message-content" v-if="list">
            <div class="post-comment-area" id="user-comment" ref="container">
                <div class="input-name">
                    <input type="text" placeholder="用户昵称" v-model="MessageForm.nickname"
                        @blur="handleChangeName($event.target.value)" @input="handleNameWord($event.target.value)"
                        maxlength="10">
                    <div class="name-prompt">{{ wordLength }}/10</div>
                    <div class="name-info" v-if="nameInfo">请填写昵称</div>
                </div>
                <div class="input-content">
                    <textarea placeholder="输入内容" v-model="MessageForm.content"
                        @blur="handleChangeContent($event.target.value)" class="textarea"></textarea>
                    <div class="content-info" v-if="contentInfo">请输入内容</div>
                </div>
                <button class="comment-btn" @click="handleSubmit" :disabled="isSubmit">提交</button>
            </div>
            <div class="user-comment-area" v-if="list">
                <div class="comment-total">列表评论({{ list.total }})</div>
                <div class="user-comment-area">
                    <div v-for="item in list.rows" :key="item.id" class="comment-item">
                        <div class="comment-img">
                            <img :src="item.avatar" alt="">
                        </div>
                        <div class="userInfo-content">
                            <div class="nickname">
                                <span>{{ item.nickname }}</span>
                                <span class="nickname-date">{{ timestampToComplectTime(+item.createDate) }}</span>
                            </div>
                            <div class="comment-content">{{ item.content }}</div>
                        </div>
                    </div>
                </div>
                <div class="isLoading" v-loading="isLoading"></div>
            </div>
        </div>

    </div>
</template>
  
<script>
import { postMessage, getMessage } from '@/api/message';
import showMessage from '@/utils/showMessage';
import eventBus from '@/eventBus'
export default {
    data() {
        return {
            list: null,
            isLoading: false,
            MessageForm: {
                nickname: "",
                content: ""
            },
            wordLength: 0,
            nameInfo: false,
            contentInfo: false,
            isSubmit: false,
            page: 1,
            limit: 10,
            dataLoading: true
        }
    },
    created() {
        eventBus.$on('setScrollTop', this.handleTotop)
        getMessage().then(r => {
            this.list = r.data.data
            this.dataLoading = false
        })
    },
    mounted() {
        this.$refs.messageContainer.addEventListener('scroll', this.getMorelist)//评论滚动事件;
        this.$refs.messageContainer.addEventListener('scroll', this.handleScrollMessage)
    },
    beforeDestroy() {
        eventBus.$emit('messageScroll');
        this.$refs.messageContainer.removeEventListener('scroll', this.getMorelist)//评论滚动事件;
        this.$refs.messageContainer.removeEventListener('scroll', this.handleScrollMessage);
        eventBus.$off('setScrollTop', this.handleTotop)

    },
    methods: {
        handleChangeName(info) {
            if (!info) {
                this.nameInfo = true;
                return
            } else {
                this.nameInfo = false
                return
            }
        },
        handleNameWord(word) {
            if (word.length > 10) {
                // this.$refs.input.style.readonly = true
                return
            } else {
                this.wordLength = word.length
            }
        },
        handleChangeContent(content) {
            if (!content) {
                this.contentInfo = true;
                return
            } else {
                this.contentInfo = false
                return
            }
        },
        handleSubmit() {
            this.isSubmit = true;
            postMessage(this.MessageForm).then(r => {
                if (this.MessageForm.nickname && this.MessageForm.content) {
                    this.list.rows.unshift(r.data.data)
                    showMessage({ type: 'chenggong', content: '评论成功', container: this.$refs.container });
                    this.list.total++;
                    this.MessageForm.nickname = '';
                    this.MessageForm.content = '';
                    this.wordLength = 0;
                    this.isSubmit = false;
                } else {
                    showMessage({ type: 'cuowu', content: '评论失败，请输入完整评论', container: this.$refs.container })
                    this.MessageForm.nickname = '';
                    this.MessageForm.content = '';
                    this.wordLength = 0;
                    this.isSubmit = false;
                    return;
                }
            })
        },
        timestampToComplectTime(timestamp) {
            const CurTimestamp = Number(timestamp);
            var date = new Date(CurTimestamp);
            // // 提取年、月、日、时、分、秒
            var year = date.getFullYear();
            var month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份加1并补0
            var day = date.getDate().toString().padStart(2, '0'); // 补0
            var hour = date.getHours();
            var minute = date.getMinutes();
            var second = date.getSeconds();
            if (second < 10) {
                second = "0" + second
            }
            if (minute < 10) {
                minute = "0" + minute
            }
            if (hour < 10) {
                hour = "0" + hour
            }
            // 格式化时间字符串
            var dateTimeString = year + '-' + month + '-' + day + '   ' + hour + ':' + minute + ':' + second;
            // 返回格式化后的时间字符串
            return dateTimeString;
        },
        getMorelist(dom) {
            if (!this.list || this.isLoading === true) {
                return
            }
            if (dom) {
                if (Math.abs(dom.target.scrollHeight - dom.target.clientHeight - dom.target.scrollTop) < 200) {
                    if (this.list.rows.length >= this.list.total) {
                        return
                    }
                    //已经滑到最低部
                    this.isLoading = true
                    this.page++;
                    getMessage(this.page, this.limit).then(r => {
                        this.list.rows = this.list.rows.concat(r.data.data.rows)
                        this.isLoading = false
                    })
                }
            }
        },
        handleScrollMessage(dom) {
            eventBus.$emit('messageScroll', dom)
        },
        handleTotop(scrollPos) {
            if (this.$refs.messageContainer) {
                this.$refs.messageContainer.scrollTop = scrollPos

            }
        }
    }

}
</script>

<style lang="less" scoped>
.message-container {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
    scroll-behavior: smooth;

    .user-message-content {
        width: 60%;
        height: 100%;
        margin: 0 auto;
    }
}

.post-comment-area {
    width: 100%;
    margin-top: 30px;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;

    .input-name {
        width: 50%;
        height: 40px;
        position: relative;

        input {
            width: 100%;
            height: 100%;
            border-style: dashed;
            padding-left: 10px;
            font-size: 16px;
        }
    }

    .input-content {
        margin-top: 30px;
        width: 100%;
        height: 200px;

        .textarea {
            display: block;
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            border-style: dashed;
            font-size: 14px;
            padding: 5px 5px;
            resize: none;
        }
    }

    .comment-btn {
        margin-top: 30px;
        width: 100px;
        height: 40px;
        background: rgb(0, 0, 180);
        font-size: 14px;
        color: #fff;
        border-radius: 7px;
        cursor: pointer;
    }

    .comment-btn[disabled] {
        cursor: not-allowed;
        opacity: 0.5;
    }
}

.user-comment-area {
    width: 100%;
    margin-top: 30px;

    .comment-total {
        font-weight: bolder;
        font-size: 18px;
    }

    .user-comment-area {
        width: 100%;
    }

    .comment-img {
        width: 50px;
        height: 50px;
        margin-right: 15px;

        img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
        }
    }

    .nickname-date {
        position: absolute;
        right: 20px;
        font-size: 12px;
        color: #999;
    }

    .comment-item {
        display: flex;
        width: 100%;
        border-bottom: 1px solid #999;
        box-sizing: border-box;
        padding: 20px 0;
    }

    .userInfo-content {
        width: 100%;

        .nickname {
            color: #009900;
            font-weight: bolder;
            position: relative;
        }

        .comment-content {
            margin-top: 12px;
            font-size: 14px;
        }
    }
}

.name-prompt {
    position: absolute;
    right: 0;
    bottom: 0;
    color: #999;
    font-size: 12px;
}

.name-info,
.content-info {
    color: rgb(240, 0, 0);
}

.isLoading {
    position: relative;
    width: 100%;
    height: 80px;
}
</style>